module Tapas.Bindings {
    export class Filter {
        public init(element: any, valueAccessor: () => any, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {
            if (!bindingContext)
                return;
            
            var filter = {
                __filters: null,
                __filterSelectors: null,
                __filterSearch: null,
                __filterSearchLastValue: "",
                __filterIds: null,
                __documentsContainer: null,
                __documents: null,
                __distinctFilterValues: [],
                __resetBtn: null,
                __timeout: null,
                __primaryFilterId: null,
                __update: null,

                init: function () {
                    var _this = this;
                    this.__primaryFilterId = $(".filters").attr("ftw-filter-primary");
                    this.__update = ($(".filters").attr("ftw-filter-update") == "true");
                    this.__filters = $(".filters .filter");
                    this.__filterSelectors = $(".filters .filter select");
                    this.__filterSearch = $(".freetext")
                    this.__filterIds = this.__filters.map(function () { return $(this).attr('ftw-filter-id'); });
                    this.__documentsContainer = $(".filterrows");
                    this.__documents = $(".filterrows .filterrow");
                    this.__resetBtn = $(".filters .resetbtn");
                    this.__filterIds.each(function () {
                        var filterid = this;
                        var distinctValues : any = { id: filterid, values: jQuery.unique(_this.__documents.filter("[ftw-filter-" + filterid + "!='']").map(function () { return $(this).attr("ftw-filter-" + filterid); })) };
                        distinctValues.values.sort();
                        _this.__distinctFilterValues.push(distinctValues);

                        var filterSelect = _this.__filterSelectors.filter("[ftw-filter-id='" + filterid + "']");
                        if (distinctValues.values.length > 0) {
                            _this.__filters.filter("[ftw-filter-id  ='" + filterid + "']").show();
                            distinctValues.values.each(function () {
                                if (filterSelect.find("option[value='" + this + "']").length < 1) //Ekstra IE tjek for dubletter
                                    filterSelect.append($("<option>").attr("value", this).text(this));
                            });
                        }
                    });

                    this.__filterSelectors.off('change').on('change', { base: this }, this.onFilterChange);
                    this.__filterSearch.off('keyup').on('keyup', { base: this }, this.onFilterSearchChange);

                    this.__resetBtn.off('click').on('click', { base: this }, this.onResetBtnClick);
                },
                unique: function (array) {
                    return $.grep(array, function (el, index) {
                        return index == $.inArray(el, array);
                    });
                },
                onFilterChange: function (_event) {
                    var base = _event.data.base;
                    
                    if ($(this).attr("ftw-filter-id") == base.__primaryFilterId) {
                        if ($(this).val() == "") {
                            $(base.__filterSelectors[1]).val('').prop("disabled", true);
                        }
                        else {
                            var newdistinctValues = { id: "attr2", values: jQuery.unique(base.__documents.filter("[ftw-filter-attr1='" + $(this).val() + "']").map(function () { return $(this).attr("ftw-filter-attr2"); })) };
                            if (newdistinctValues.values.length > 1) {
                                $(base.__filterSelectors[1]).find("option").hide();

                                var optionsToShow = $(base.__filterSelectors[1]).find("option").filter(function () {

                                    if (jQuery.inArray($(this).val(), newdistinctValues.values) > -1)
                                        return true;

                                    return false;
                                });

                                if (optionsToShow.length > 1) {
                                    optionsToShow.show();
                                    $(base.__filterSelectors[1]).val('').prop("disabled", false);
                                }
                                else {
                                    $(base.__filterSelectors[1]).val('').prop("disabled", true);
                                }
                            }
                            else {
                                $(base.__filterSelectors[1]).val('').prop("disabled", true);
                            }
                        }


                    }

                    base.updateFilter();
                },

                onFilterSearchChange: function (_event) {
                    var base = _event.data.base;
                    if (base.__filterSearchLastValue == base.__filterSearch.val())
                        return;

                    clearTimeout(base.__timeout);
                    base.__timeout = setTimeout(function () {
                        base.updateFilter();
                    }, 400);

                },

                onResetBtnClick: function (_event) {
                    var base = _event.data.base;
                    base.resetFilter();
                },

                resetFilter: function () {
                    this.__documents.show();
                    this.__filterSelectors.val("");
                    this.__filterSearch.val("");

                    $(".doccount .count").text(this.__documents.length);
                   // this.__documentsContainer.hide();

                    if (this.__update)
                        this.updateFilterFacets(this.__documents);
                },

                updateFilter: function () {
                    var base = this;
                    var documentsToShow = this.__documents;
                    var activeFilters = this.__filterSelectors.filter(function () { return $(this).val() != ""; })

                    if (activeFilters.length == 0 && this.__filterSearch.val() == "") {
                        this.__documents.fadeIn();

                    }
                    else {
                        this.__documents.hide()

                        var documentsFilter = "";
                        activeFilters.each(function () {
                            documentsFilter += "[ftw-filter-" + $(this).attr('ftw-filter-id') + "='" + $(this).val() + "']";
                        });

                        if (documentsFilter != "")
                            documentsToShow = documentsToShow.filter(documentsFilter);
                        base.__filterSearchLastValue = base.__filterSearch.val();

                        if (base.__filterSearch.val() != "") //If search 
                        {
                            var q = base.__filterSearch.val().toLowerCase();
                            documentsToShow = documentsToShow.filter(function () {

                                return (
                                    ($(this).attr('ftw-filter-freetext').toLowerCase().indexOf(q) > -1)
                                    ||
                                    ($(this).attr('ftw-filter-attr1') != null && $(this).attr('ftw-filter-attr1').toLowerCase().indexOf(q) > -1)
                                    ||
                                    ($(this).attr('ftw-filter-attr2') != null && $(this).attr('ftw-filter-attr2').toLowerCase().indexOf(q) > -1)
                                    ||
                                    ($(this).attr('ftw-filter-attr3') != null && $(this).attr('ftw-filter-attr3').toLowerCase().indexOf(q) > -1)
                                    ||
                                    ($(this).attr('data-filter-attr4') != null && $(this).attr('ftw-filter-attr4').toLowerCase().indexOf(q) > -1)
                                    ||
                                    ($(this).attr('ftw-filter-attr5') != null && $(this).attr('ftw-filter-attr5').toLowerCase().indexOf(q) > -1)
                                );
                            });
                        }

                        base.__documentsContainer.show();
                        documentsToShow.fadeIn();

                    }

                    $(".doccount .count").text(documentsToShow.length);

                    if (base.__update)
                        base.updateFilterFacets(documentsToShow);
                },
                updateFilterFacets: function (visibleDocuments) {
                    var base = this;

                    base.__filterSelectors.each(function () {
                        var filterAttr = $(this).data("filter");

                        var newdistinctValues = { id: filterAttr, values: jQuery.unique(visibleDocuments.map(function () { return $(this).attr("ftw-filter-" + filterAttr); })) };
                        $(this).find("option").hide();
                        $(this).find("option[value='']").show();
                        $(this).find("option[value='" + $(this).val() + "']").show();

                        var optionsToShow = $(this).find("option").filter(function () {

                            if (jQuery.inArray($(this).val(), newdistinctValues.values) > -1)
                                return true;

                            return false;
                        });

                        if (optionsToShow.length > 0) {
                            optionsToShow.show();
                        }
                    });
                }
            }

            filter.init();


        }
    }
    ko.bindingHandlers['filter'] = new Filter();
}